import { useState } from 'react';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';

import Container from '../../../../components/Container';
import Main from '../../../../layouts/Main';
import {Alert, Box, Divider, Link, Stack, ToggleButton, ToggleButtonGroup, useMediaQuery, useTheme } from '@mui/material';
import PageBreadcrumbs from '../../../../components/PageBreadcrumbs';
import CommitteeList from './components/CommitteeList';
import ChangeOfPurposeList from './components/ChangeOfPurposeList';


const RecentlyOrganized = (): JSX.Element => {
    
    document.title = 'OCPF - Recently Organized';

    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
         defaultMatches: true,
    });

    //default tab
    const filerTypes = ['Candidates', 'Change of Purpose', 'PACs', 'Ballot Questions', 'Segregated Accounts'];
    const [filerType, setFilerType] = useState('Candidates');

    const switchFilerType = (event: any, newType: string) => {
        if (newType !== null) {
            setFilerType(newType);
        }
      };

   return (
    <Main>
      <Container>
        <PageBreadcrumbs></PageBreadcrumbs>
        <Typography
            variant="h5"
            align={'left'}
            sx={{
                fontWeight: 700,
            }}
            paddingTop={3}
            gutterBottom
            marginBottom={2}
            >
            Recently Organized Filers
        </Typography>
        <Stack sx={{ width: '100%' }} spacing={2}>
            <Alert severity="info">Follow <Link target="_blank" href="https://x.com/OCPFORG">OCPFORG</Link> on X for up-to-date announcements on newly organized candidates and political committees, as well as candidates who change their office sought.</Alert>
        </Stack>
        <Divider/>
        <Grid container marginTop={3}>
            <Grid size={12} display={'flex'} flexWrap={'wrap'}>
                <ToggleButtonGroup
                    exclusive
                    fullWidth = {isMd? false: true}
                    aria-label="filer types"
                    size="small"
                    color="primary"
                    value={filerType}
                    onChange={switchFilerType}
                >
                    {filerTypes.slice(0,3).map((type) => (
                        <ToggleButton 
                            key={type} 
                            value={type} 
                            aria-label={`filer data - ${type}`}
                            sx={{fontWeight:800, width: isMd? 200: "auto"}}
                        >
                            {type}
                        </ToggleButton>
                    ))}
                </ToggleButtonGroup>
                <ToggleButtonGroup
                     exclusive
                     fullWidth = {isMd? false: true}
                     aria-label="filer content types"
                     size="small"
                     color="primary"
                     value={filerType}
                     onChange={switchFilerType}
                >
                    {filerTypes.slice(3).map((type) => (
                        <ToggleButton key={type} value={type} aria-label={`filer data - ${type}`}
                            sx={{fontWeight:800, width: isMd? 200: "auto"}}
                        >
                            {type}
                        </ToggleButton>
                    ))}
                </ToggleButtonGroup>
            </Grid>
            <Grid size={12}>
                <Box>
                {
                    filerType === 'Change of Purpose' && <ChangeOfPurposeList></ChangeOfPurposeList>
                }
                {
                    filerType === 'Candidates' && <CommitteeList tpye={'C'}></CommitteeList>
                }
                {
                    filerType === 'PACs' && <CommitteeList tpye={'P'}></CommitteeList>
                }
                {
                    filerType === 'Ballot Questions' && <CommitteeList tpye={'B'}></CommitteeList>
                }
                {
                    filerType === 'Segregated Accounts' && <CommitteeList tpye={'S'}></CommitteeList>
                }    
                </Box>
            </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default RecentlyOrganized;